// Horizontal bar list. Expects rows with one categorical column
// (the label) and one numeric column (the value). Discovers the
// two columns automatically — first non-numeric column is the
// label, first numeric column is the value.

interface Props {
  rows: Record<string, unknown>[];
}

const fmt = new Intl.NumberFormat('en-AU');

export function BarList({ rows }: Props) {
  const keys = Object.keys(rows[0] ?? {});
  const valueKey =
    keys.find((k) => rows.every((r) => typeof r[k] === 'number')) ?? keys[1] ?? '';
  const labelKey = keys.find((k) => k !== valueKey) ?? keys[0] ?? '';
  const max = rows.reduce((acc, r) => {
    const v = Number(r[valueKey]);
    return Number.isFinite(v) && v > acc ? v : acc;
  }, 0);

  return (
    <ul className="bar-list">
      {rows.map((row, i) => {
        const v = Number(row[valueKey] ?? 0);
        const pct = max > 0 ? (v / max) * 100 : 0;
        return (
          <li key={`${String(row[labelKey])}-${i}`}>
            <div className="bar-row">
              <span className="bar-label">{String(row[labelKey] ?? '—')}</span>
              <span className="bar-value">{fmt.format(v)}</span>
            </div>
            <div className="bar-track">
              <div className="bar-fill" style={{ width: `${pct}%` }} />
            </div>
          </li>
        );
      })}
      <style>{styles}</style>
    </ul>
  );
}

const styles = `
.bar-list { list-style: none; margin: 0; padding: 0; width: 100%; }
.bar-list li { margin-bottom: 8px; }
.bar-list li:last-child { margin-bottom: 0; }
.bar-row { display: flex; justify-content: space-between; font-size: 13px; color: var(--ac-grey-700); margin-bottom: 4px; }
.bar-label { font-weight: 500; }
.bar-value { font-variant-numeric: tabular-nums; color: var(--ac-grey-500); }
.bar-track { width: 100%; height: 6px; background: var(--ac-grey-100); border-radius: 999px; overflow: hidden; }
.bar-fill { height: 100%; background: var(--ac-blue-mid); border-radius: 999px; transition: width 200ms ease; }
`;
